import { Link } from "react-router-dom";
import { IconArrowBottom } from "./icons/Icons";

const ButtonMenu = ({ icon, title, url }) => {
  return (
    <div>
      <Link
        to={`${url}`}
        className="bg-gradient-to-r from-[#a4b3d6] from-2% to-[#14639b] to-98% text-white p-5 rounded-lg flex items-start gap-1 font-light flex-col transition-all duration-500 ease-in-out hover:scale-105 transform hover:shadow-md hover:bg-gradient-to-r hover:from-[#a4b3d6] hover:from-15% hover:to-[#14639b] hover:to-85% group"
      >
        {icon}
        <div className="flex justify-between items-center w-full">
          <span className="text-2xl font-medium">{title}</span>
          <IconArrowBottom className="w-4 -rotate-90 opacity-0 group-hover:opacity-100 transition-opacity duration-300" />
        </div>
      </Link>
    </div>
  );
};

export default ButtonMenu;
